import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../view/index.vue'
import Detail from '../view/detail.vue'
import Search from '../view/search.vue'
import Special from '../view/special.vue'
import Channe from '../view/channe.vue'
import Live from '../view/live.vue'
Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  // base:"/",
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: { title: "四川手机报" }
    },
    {
      path: '/channe/:id',
      name: 'channe',
      component: Channe,
      meta: { title: "四川手机报" }
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: Detail,
    },
    {
      path: '/search/:keys',
      name: 'search',
      component: Search,
      meta: { title: "搜索 - 四川手机报" }
    },
    {
      path: '/special/:id',
      name: 'special',
      component: Special,
      meta: { title: "专题 - 四川手机报" }
    },
    {
      path: '/live/:id',
      name: 'live',
      component: Live,
      meta: { title: "直播 - 四川手机报" }
    }

  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router


// server {
//   listen       8888;#默认端口是80，如果端口没被占用可以不用修改
//   server_name  localhost;
//   root        E:/vue/my_project/dist;#vue项目的打包后的dist
//   location / {
//     try_files $uri $uri/ @router;#需要指向下面的@router否则会出现vue的路由在nginx中刷新出现404
//   index  index.html index.htm;
// }
//   #对应上面的@router，主要原因是路由的路径资源并不是一个真实的路径，所以无法找到具体的文件
//   #因此需要rewrite到index.html中，然后交给路由在处理请求资源
//   location @router {
//     rewrite ^.*$ /index.html last;
//   }
//
// }
